import { render } from "./BaseSpinner.vue?vue&type=template&id=415fcb68&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=415fcb68&scoped=true&lang=css"

import exportComponent from "/Users/huangyuhao/Desktop/art-sleuth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415fcb68"]])

export default __exports__